import { useCallback, useEffect, useState } from "react";
import { getDropDownOfflineChannel } from "../../services/customerStakeholder";

const useOfflineChannel = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getDropDownOfflineChannel();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useOfflineChannel;
